import React, { Component } from 'react';
import {Modal} from "antd";

class VideoIntroFreeAccountModal extends Component {
  constructor(props) {
    super(props);

    this.state = {

    }
  }

  render() {
    const { showModal, handleHiddenModal } = this.props;
    const urlVideo = 'https://www.youtube.com/watch?v=K8cI8CxJPDs&ab_channel=BunkeyDAM';

    return (
      <Modal
        visible={showModal}
        footer={false}
        className="modal-parent"
        centered
        width={940}
        onCancel={handleHiddenModal}
      >
        <div style={{ height: 486, background: '#292929', }}>
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${YouTubeGetID(urlVideo)}`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        {/*<VideoView*/}
        {/*  url={`https://www.youtube.com/embed/${YouTubeGetID(urlVideo)}`}*/}
        {/*  disableDefaultControls={false}*/}
        {/*  autoPlay={false}*/}
        {/*  muted={true}*/}
        {/*/>*/}
      </Modal>
    );
  }
}

function YouTubeGetID(url) {
  if (!url) return null;
  const _url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  return url[2] !== undefined ? _url[2].split(/[^0-9a-z-]/i)[0] : _url[0];
}

export default VideoIntroFreeAccountModal;
